<div #header class="w-full">
  <app-modal-header
    #modal_header
    [isDialog]="true"
    [state]="state"
    [label]="label()"
    (onOkClick)="doOk($event)"
    (onReady)="modalHeaderReady($event)"
    (onCancelClick)="doCancel($event)"
  >
  </app-modal-header>
</div>
<!-- <div mat-dialog-title class="dialog-title" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle
  style="display: flex; justify-content: space-between; align-items: center;">
  <span>{{label()}}</span>
  <button (click)="doOk($event)">
    離開
  </button>
</div>
 -->
<div class="jk-content">
  <div class="div-flex">
    <button (click)="navigateUp()" [disabled]="pathDisabled">
      <span>↑ 上一層</span>
    </button>
    <input
      #imageInput
      type="file"
      accept="image/*"
      style="display: none"
      (change)="onImageFileSelected($event)"
    />
    <button class="btn-primary" (click)="imageInput.click()">
      <span>上傳圖片</span>
    </button>
    <button class="btn-primary" (click)="pasteImageFromClipboard()">
      <span>貼上圖片</span>
    </button>

    <button
      class="btn-normal"
      (click)="showNewFolderDialog = true"
      [disabled]="pathDisabled"
    >
      <span>新增資料夾</span>
    </button>

    <label class="btn-normal">
      <span>上傳檔案</span>
      <input
        type="file"
        [multiple]="multiple"
        (change)="onFileSelected($event)"
        style="display: none"
      />
    </label>

    <button
      class="btn-normal"
      (click)="deleteSelectedItems()"
      [disabled]="selectedItems.length === 0"
    >
      <span>刪除已選檔案</span>
    </button>
    <a
      #downloadLink
      id="downloadLink"
      style="display: none"
      [href]="downloadUrl"
      download
      >下載點</a
    >
  </div>

  <!-- 新增資料夾對話框 -->
  @if (showNewFolderDialog) {
    <div class="dialog-overlay">
      <div class="dialog">
        <h3>新增資料夾</h3>
        <div class="dialog-content">
          <input
            type="text"
            [(ngModel)]="newFolderName"
            placeholder="請輸入資料夾名稱"
          />
        </div>
        <div class="dialog-actions">
          <button (click)="showNewFolderDialog = false">取消</button>
          <button (click)="createFolder()" type="submit" autofocus>確定</button>
        </div>
      </div>
    </div>
  }

  <!-- 檔案拖放區域 -->
  <div
    class="drop-zone"
    [class.drag-over]="dragOver"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    @if (fileList.length === 0 && !isLoading) {
      <div class="drop-message">
        <p>{{ labelText }}</p>
      </div>
    }

    <!-- 載入中指示器 -->
    @if (isLoading) {
      <div class="loading">
        <p>載入中...</p>
      </div>
    }

    <!-- 檔案列表 -->
    @if (!isLoading) {
      <table class="file-list">
        <thead class="border-2">
          <tr>
            <th style="width: 30px"></th>
            <th>動作</th>
            <th>名稱</th>
            <th>類型</th>
            <th>大小</th>
            <th>修改日期</th>
          </tr>
        </thead>
        <tbody>
          @for (item of fileList; track item.path) {
            <tr
              [class.selected]="isSelected(item)"
              (click)="navigateToFolder(item)"
            >
              <td>
                <!--                 <input
                  type="checkbox"
                  [checked]="isSelected(item)"
                  (click)="toggleSelection(item, $event)"
                />
 -->
                <app-jkcheckbox
                  label=""
                  #MA015Com
                  id="MA015"
                  [value]="isSelected(item)"
                  (valueChange)="jkToggleSelection(item)"
                >
                </app-jkcheckbox>
              </td>
              <td>
                <button class="btn-normal" (click)="downloadFile(item)">
                  <span>下載</span>
                </button>
              </td>
              <td>
                @if (item.type === "folder") {
                  <span class="folder-icon">📁</span>
                } @else {
                  <span class="file-icon">📄</span>
                }
                {{ item.name }}
              </td>
              <td>{{ item.type === "folder" ? "資料夾" : "檔案" }}</td>
              <td>
                {{ item.type === "folder" ? "-" : formatFileSize(item.size) }}
              </td>
              <td>{{ formatDate(item.modified) }}</td>
            </tr>
          }
        </tbody>
      </table>
    }
  </div>
  <div class="path-navigation">
    <app-jktext label="當前路徑" [value]="currentDirectory"> </app-jktext>
    <app-jktext label="主機" [value]="uploadHost + uploadBaseUrl"> </app-jktext>
  </div>
</div>
